import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Theme from "./plugins/theme-kit";
import "./registerServiceWorker";
import i18n from "./i18n";
import VueGtag from "vue-gtag";

Vue.config.productionTip = false;
Vue.use(Theme);
Vue.use(VueGtag, {
  config: {id: "G-KJ3ZBES7DZ"}
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
